import './Banner.scss';

import classnames from 'classnames';
import React from 'react';
import useAprExamples from '../../hooks/useAprExamples';
import { useSelector } from 'react-redux';

import AoIcon from '@ao-internal/components-react/lib/Icon/Icon';

import { useIsBelowMediumOnly } from '../../hooks/mediaQueries';
import useCardView from '../../hooks/useCardView';
import { useTheme } from '../../hooks/useTheme';
import TRANSLATIONS from '../../translations/translations@default.json';
import { Switch24BannerTerms } from './Switch24BannerTerms';

const DesktopFinanceBanner = ({ index }) => {
	const {
		showSwitch24Example,
		financeRepExampleText,
		aprPurchaseRate,
		aprRepresentative,
	} = useAprExamples();

	const { isDealsPage } = useSelector((state) => state);

	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const { isGridView } = useCardView();

	const theme = useTheme('financeBanner');

	const titleStyles = classnames(
		'flex-col text-title-sm leading-tight',
		theme.repExample.examples.title
	);

	const isBelowMediumOnly = useIsBelowMediumOnly();

	const gridSize = isGridView && (isDealsPage || isBelowMediumOnly) ? 4 : 3;

	if (gridSize !== index) {
		return null;
	}

	return (
		<li
			className={classnames(
				'flex w-full p-4 my-2 border border-solid border-gray-30 rounded-lg',
				theme.background,
				{
					'lg:mx-4 xl:mx-0': CustomCategoriesEnabled,
				}
			)}>
			<div className="flex flex-col flex-shrink-0 items-center justify-center w-1/4 mr-6 lg:flex-row">
				<AoIcon
					size="3x"
					icon="finance-gbp"
					className="text-cta-main mb-2 lg:mb-0 lg:mr-2"
				/>
				<div className="flex-col">
					<div className="flex-col text-title-sm lg:text-title-lg leading-tight text-primary">
						AO Finance
					</div>
					<div
						className={classnames(
							'text-left font-body leading-none mt-2 text-body-xs'
						)}>
						Pay your way
					</div>
				</div>
			</div>
			<div className="mr-4" style={{ borderRight: '1px solid #E2E7E8' }}></div>
			<div className="flex-col justify-around w-full">
				<div className={titleStyles} data-testid="finance-rep-example-title">
					{financeRepExampleText}
				</div>
				<div
					className={classnames(
						'font-body leading-tight mt-3 text-body-xs',
						theme.repExample.examples.description
					)}>
					Representative{' '}
					<span className={titleStyles}>{aprRepresentative}% APR</span>{' '}
					(variable), <span className={titleStyles}>{aprPurchaseRate}% PA</span>{' '}
					purchase rate (variable),{' '}
					<span className={titleStyles}>
						{
							TRANSLATIONS.listerFooter.financeExample
								.assumedCreditLimitAmountText
						}
					</span>{' '}
					assumed credit limit.
				</div>
				<div
					className={classnames(
						'font-body leading-snug mt-3 text-body-xs',
						theme.terms
					)}>
					18+, Credit and Offers are subject to status. Terms apply. NewDay Ltd,
					UK Only.
					<span className="font-bold">
						{' '}
						AO Retail Limited acts as a credit broker exclusively for NewDay Ltd
						and is not a lender.
					</span>
					{showSwitch24Example && <Switch24BannerTerms />}
				</div>
				<div
					className={classnames(
						'font-body leading-snug mt-3 text-body-xs',
						theme.terms
					)}>
					<span>
						{TRANSLATIONS.listerFooter.financeExample.creditUpfrontText}
					</span>
				</div>
			</div>
		</li>
	);
};

export default DesktopFinanceBanner;
